import { InjectionToken } from '@angular/core';

export interface AdminShellBranding {
  appName: string;
  logoUrl: string;
}

export const ADMIN_SHELL_BRANDING = new InjectionToken<AdminShellBranding>('ADMIN_SHELL_BRANDING');
